module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker44-api.relevant-digital.com/"}};